"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTableData = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const strings_1 = require("../../../../../constants/strings");
const teamQuery_1 = require("../../../../../queries/teamQuery");
const userQuery_1 = require("../../../../../queries/userQuery");
const zustandStore_1 = require("../../../../../zustandStore");
const logger = (0, pino_1.default)();
const useGetTableData = (teams, page) => {
    const navigate = (0, react_router_1.useNavigate)();
    const LIMIT = 5;
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const { team, setTeamId, setTeam } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const { teamId } = team;
    const saveUserSetting = (0, userQuery_1.useSaveUserSettingQuery)();
    const setCurrentTeamById = (0, teamQuery_1.useSetCurrentTeamByIdQuery)();
    const open = Boolean(anchorEl);
    const handleClick = (event, team) => {
        setTeamId(team.id);
        setTeam(team);
        saveUserSetting.mutate({ selectedTeamID: String(team.id) || '' });
        setAnchorEl(event.currentTarget);
    };
    const goToTeamDashboard = () => {
        setAnchorEl(null);
        void navigate(`/dashboard/team/${teamId}`);
    };
    const goToTeamSettings = (0, react_1.useCallback)(() => {
        if (teamId === undefined) {
            logger.error(`goToTeamSettings setCurrentTeamById(${teamId})`);
            return;
        }
        setCurrentTeamById.mutate(teamId, {
            onSuccess: () => {
                void navigate('/team/overview');
            },
            onError: () => {
                logger.error(`goToTeamSettings setCurrentTeamById(${teamId})`);
            },
        });
    }, [setCurrentTeamById, teamId, navigate]);
    if (teams && teams.length > 0) {
        return (LIMIT > 0 ? teams.slice((page - 1) * LIMIT, (page - 1) * LIMIT + LIMIT) : teams).map(team => [
            {
                id: 'team',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "column", children: (0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: team?.teamName, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: { width: '200px' }, variant: "subtitle2", "ts-variant": 'tableCellTitleName', children: team?.name || '' }) }) }));
                },
            },
            {
                id: 'teamNumberOfMembers',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", "ts-variant": 'tableCellTitle', children: team.numberOfMembers || 0 }));
                },
            },
            {
                id: 'teamCards',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "column", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", "ts-variant": 'tableCellTitle', children: team.activeCardCount }) }));
                },
            },
            {
                id: 'approved',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "column", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", "ts-variant": 'tableCellTitle', sx: { whiteSpace: 'normal', width: '120px' }, children: team.totalApprovedAmount }) }));
                },
            },
            {
                id: 'spent',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "column", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", "ts-variant": 'tableCellTitle', sx: { whiteSpace: 'normal', width: '120px' }, children: team.totalSpentAmount }) }));
                },
            },
            {
                id: 'available',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "column", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", "ts-variant": 'tableCellTitle', sx: { whiteSpace: 'normal', width: '120px' }, children: team.totalAvailableBalance }) }));
                },
            },
            {
                id: 'teamActions',
                ui() {
                    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, direction: "row", sx: {
                            justifyContent: 'flex-end',
                            alignItems: 'flex-end',
                        }, children: [(0, jsx_runtime_1.jsxs)(material_1.Button, { id: "basic-button", "data-testid": "basic-button", "ts-variant": "actionButton", "aria-controls": open ? 'basic-menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: e => handleClick(e, team), variant: "text", sx: { color: 'hsl(199, 100%, 50%)' }, children: [(0, jsx_runtime_1.jsx)("span", { children: "\u2022" }), (0, jsx_runtime_1.jsx)("span", { children: "\u2022" }), (0, jsx_runtime_1.jsx)("span", { children: "\u2022" })] }), (0, jsx_runtime_1.jsxs)(material_1.Menu, { id: "basic-menu", anchorEl: anchorEl, open: open, onClose: () => setAnchorEl(null), MenuListProps: {
                                    'aria-labelledby': 'basic-button',
                                }, children: [(0, jsx_runtime_1.jsx)(material_1.MenuItem, { onClick: goToTeamDashboard, children: strings_1.dashboardStrings.TEAM_DASHBOARD }), (0, jsx_runtime_1.jsx)(material_1.MenuItem, { onClick: goToTeamSettings, children: strings_1.dashboardStrings.TEAM_SETTINGS })] })] }));
                },
            },
        ]);
    }
    return [];
};
exports.useGetTableData = useGetTableData;
